import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLibreOfficeLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "linearGradient3898",
		x1: 4,
		x2: 28,
		y1: 31,
		y2: 1,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "#007c3c",
			offset: 0
		}), /* @__PURE__ */ _jsx("stop", {
			stopColor: "#78fc4e",
			offset: 1
		})]
	}) }), /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		strokeLinecap: "square",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m7 0c-2.216 0-4 1.784-4 4v24c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-16l-12-12h-10zm13 0 9 9v-9h-9z",
				fill: "url(#linearGradient3898)"
			}),
			/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				d: "m3 27v1c0 2.216 1.784 4 4 4h18c2.216 0 4-1.784 4-4v-1c0 2.216-1.784 4-4 4h-18c-2.216 0-4-1.784-4-4z",
				fillOpacity: .19862
			}), /* @__PURE__ */ _jsx("path", {
				d: "m20 0h1.4l7.6 7.6v1.4z",
				fillOpacity: .20149
			})] }),
			/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				d: "m9 13c-0.554 0-1 0.446-1 1v7c0 0.554 0.446 1 1 1h6v-1h-2v-1h2v-1h-2v-1h8v-4c0-0.554-0.446-1-1-1zm0 1h3v1h-3zm4 0h3v1h-3zm4 0h3v1h-3zm-8 2h3v1h-3zm4 0h3v1h-3zm4 0h3v1h-3zm-8 2h3v1h-3zm0 2h3v1h-3z",
				fill: "#fafafa"
			}), /* @__PURE__ */ _jsx("path", {
				d: "m16 18c-0.554 0-1 0.446-1 1v5c0 0.554 0.446 1 1 1h7c0.554 0 1-0.446 1-1v-5c0-0.554-0.446-1-1-1h-7zm2 1h1v5h-1v-5zm-2 1h1v4h-1v-4zm6 1h1v3h-1v-3zm-2 1h1v2h-1v-2z",
				fill: "#b4f48b"
			})] })
		]
	})]
});
export default SvgLibreOfficeLogo;
